import { createAction } from '@reduxjs/toolkit'

import { IHateoasLink } from '@store'
import { IBrandFanGroup } from '@store/brandFans'

export const fetchBrandFanGroups = createAction(
  'brandFanGroups/FETCH_REQUEST',
  (isNext?: boolean) => ({
    payload: {
      isNext,
    },
  }),
)

export const fetchBrandFanGroupsSuccess = createAction(
  'brandFanGroups/FETCH_SUCCESS',
  (
    brandFanGroups: ReadonlyArray<IBrandFanGroup>,
    metadata: object,
    links: ReadonlyArray<IHateoasLink>,
    isNext?: boolean,
  ) => ({
    payload: { brandFanGroups, metadata, links, isNext },
  }),
)

export const fetchBrandFanGroupsError = createAction(
  'brandFanGroups/FETCH_ERROR',
  (error: any) => ({
    payload: error,
  }),
)
